"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AuthenticationCardLogo_1 = __importDefault(require("@/Jetstream/AuthenticationCardLogo"));
function JetAuthenticationCard(_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: "min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-100" },
        react_1.default.createElement("div", null,
            react_1.default.createElement(AuthenticationCardLogo_1.default, null)),
        react_1.default.createElement("div", { className: "w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg" }, children)));
}
exports.default = JetAuthenticationCard;
